import { render, staticRenderFns } from "./Yan.vue?vue&type=template&id=0e8b2cb3&scoped=true&"
import script from "./Yan.vue?vue&type=script&lang=js&"
export * from "./Yan.vue?vue&type=script&lang=js&"
import style0 from "./Yan.vue?vue&type=style&index=0&id=0e8b2cb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8b2cb3",
  null
  
)

export default component.exports